import * as React from 'react';

function SvgComponent(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={19}
            viewBox="0 0 20 19"
            fill="none"
            {...props}
        >
            <path
                opacity={0.15}
                d="M2.932 17.806c0 .402 5.89.654 10.602.453 2.186-.094 3.533-.266 3.533-.453 0-.402-5.89-.653-10.6-.452-2.188.093-3.535.266-3.535.452z"
                fill="#45413C"
            />
            <path
                d="M1 2.214h18v15.17H1V2.215z"
                fill="#fff"
                stroke="#45413C"
                strokeWidth={0.75}
                strokeLinejoin="round"
            />
            <path
                d="M19 6.842H1V3.063c0-.47.38-.85.85-.85h16.3c.469 0 .85.38.85.85v3.78z"
                fill="#FF6242"
            />
            <path
                d="M17.971 2.214H2.028C1.46 2.214 1 2.675 1 3.244V4.53C1 3.962 1.46 3.5 2.028 3.5h15.943c.568 0 1.029.46 1.029 1.029V3.244a1.029 1.029 0 00-1.029-1.03z"
                fill="#FF6242"
            />
            <path
                d="M19 9.928v6.428c0 .568-.46 1.029-1.029 1.03h-7.2S14.885 16.098 19 9.927z"
                fill="#fff"
            />
            <path
                d="M10.771 17.385h2.314c1.485-.76 3.277-1.97 5.915-5.657v-1.8c-4.115 6.171-8.229 7.457-8.229 7.457z"
                fill="#DAEDF7"
            />
            <path
                d="M19 9.928v6.428c0 .568-.46 1.029-1.029 1.03h-7.2S14.885 16.098 19 9.927zM19 6.842H1V3.063c0-.47.38-.85.85-.85h16.3c.469 0 .85.38.85.85v3.78z"
                stroke="#45413C"
                strokeWidth={0.75}
                strokeLinejoin="round"
            />
            <path
                d="M4.857 3.757A1.543 1.543 0 116.4 2.214M10.257 3.757A1.543 1.543 0 1111.8 2.214M15.657 3.757A1.543 1.543 0 1117.2 2.214M1 9.414h18M1 11.985h10.758M1 14.556h10.758M4.6 6.842v10.543M8.2 6.842v10.543M11.8 6.842v3.49M15.4 6.842v3.96"
                stroke="#45413C"
                strokeWidth={0.75}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1 9.414h3.6v2.57H1v-2.57z"
                fill="#00DBA8"
                stroke="#45413C"
                strokeWidth={0.75}
                strokeLinejoin="round"
            />
            <path
                d="M4.6 14.556h3.6v2.829H4.6v-2.829z"
                fill="#FFE500"
                stroke="#45413C"
                strokeWidth={0.75}
                strokeLinejoin="round"
            />
            <path
                d="M8.2 6.842h3.6v2.572H8.2V6.842z"
                fill="#00DFEB"
                stroke="#45413C"
                strokeWidth={0.75}
                strokeLinejoin="round"
            />
            <path
                d="M19 9.928c-4.115 6.171-8.229 7.457-8.229 7.457a8.311 8.311 0 00.651-6.808.213.213 0 01.255-.278c1.187.324 4.77 1.118 7.323-.371z"
                fill="#fff"
                stroke="#45413C"
                strokeWidth={0.75}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default SvgComponent;
